import NewAssetButton from "app/pages/sales-intelligence/pages/home/components/common/NewAssetButton/NewAssetButton";
import withMouseEventHandlers from "app/pages/sales-intelligence/hoc/withMouseEventHandlers";
import withTrackedMouseEvents from "app/pages/sales-intelligence/hoc/withTrackedMouseEvents";
import homePageTrackingService from "app/pages/sales-intelligence/services/tracking/home-page/trackingService";
import type { ViewModelMetadata } from "app/pages/sales-intelligence/pages/home/types/models";

const NewAssetButtonTracked = withTrackedMouseEvents(
    withMouseEventHandlers(NewAssetButton),
    homePageTrackingService.cards.firstNewAssetButton,
)<ViewModelMetadata>;

export default NewAssetButtonTracked;
